<template>
    <div
        class="bg-gray-50 dark:bg-neutral-700 rounded-md border border-gray-300 dark:border-neutral-600 w-full h-full dark:text-white dark:[&_path]:!stroke-white dark:[&_line]:!stroke-white dark:[&_polygon]:!stroke-white dark:[&_.ql-picker]:!text-white">
        <!-- Use class h-full w-full for the editor -->
        <div ref="editor" class="h-full w-full">
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
        </div>
        <textarea :name="textareaName" class="hidden">{{ contentHtml }}</textarea>
    </div>
</template>
  
<script>
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

export default {
    props: {
        initialContent: {
            type: String,
            default: '', // Optional HTML to pre-fill editor
        },
        textareaName: {
            type: String,
            default: 'content', // Default field name if not provided
        },
    },
    data() {
        return {
            quill: null,
            contentHtml: this.initialContent,
        };
    },
    mounted() {
        const Block = Quill.import('blots/block');

        class FigureBlot extends Block {
            static create(value) {
                const node = super.create();
                return node;
            }
        }

        FigureBlot.blotName = 'figure';
        FigureBlot.tagName = 'figure';
        Quill.register(FigureBlot);

        this.quill = new Quill(this.$refs.editor, {
            theme: 'snow',
            placeholder: 'Write something...',
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline'],
                    [{ header: [1, 2, 3, false] }],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    ['link'],
                    ['figure']
                ]
            }
        });

        // Set initial content if provided
        if (this.contentHtml) {
            this.quill.root.innerHTML = this.contentHtml;
        }

        // Update contentHtml whenever editor changes
        this.quill.on('text-change', () => {
            this.contentHtml = this.quill.root.innerHTML;
        });
    },
    watch: {
        initialContent(newVal) {
            if (newVal && this.quill) {
                this.quill.root.innerHTML = newVal
                this.contentHtml = newVal
            }
        },
        contentHtml(newVal) {
            this.$emit('changedValue', newVal);
        }
    },
};
</script>
  
<style>
/* Make sure the container and editor take full height */
.ql-container {
    border: none !important;
    box-shadow: none !important;
}

.ql-toolbar.ql-snow {
    border: none !important;
}

.ql-editor figure img {
    border-radius: 1rem;
    margin: 16px 0;
    overflow: hidden; /* ensures child images respect the border-radius */
}

</style>
  